"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Popover", {
    enumerable: true,
    get: function() {
        return Popover;
    }
});
var _react = _interop_require_default(require("react"));
var _react1 = require("@chakra-ui/react");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var Popover = function(props) {
    return _react.default.createElement(_react1.Popover, props);
};
Popover.Trigger = _react1.PopoverTrigger;
Popover.Content = _react1.PopoverContent;
Popover.Header = _react1.PopoverHeader;
Popover.Body = _react1.PopoverBody;
Popover.Footer = _react1.PopoverFooter;
Popover.Arrow = _react1.PopoverArrow;
Popover.CloseButton = _react1.PopoverCloseButton;
Popover.Anchor = _react1.PopoverAnchor;
